import { render, staticRenderFns } from "./ArchiveTooltip.vue?vue&type=template&id=06380f1b&scoped=true&"
import script from "./ArchiveTooltip.vue?vue&type=script&lang=js&"
export * from "./ArchiveTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveTooltip.vue?vue&type=style&index=0&id=06380f1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06380f1b",
  null
  
)

export default component.exports